import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameCardBase, GC_BASE_CSS } from '@/src/app/uygulamalar/hmi-pano/pano/game-card-base';

const KAT_RENK: Record<string, string> = { 'Malzeme': '#3b82f6', 'İşçilik': '#8b5cf6', 'Dış Hizmet': '#f59e0b', 'Diğer': '#94a3b8' };
const KAT_RGB: Record<string, string> = { 'Malzeme': '59,130,246', 'İşçilik': '139,92,246', 'Dış Hizmet': '245,158,11', 'Diğer': '148,163,184' };

@Component({
  selector: 'maliyet-kalemi-kart',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="gc gc--maliyet" [style.--accent]="katRenk()" [style.--accent-rgb]="katRgb()" (mousemove)="mouseMove($event)" (mouseleave)="mouseLeave()" [ngStyle]="kartStil">
      <div class="gc-canli-bg"></div><div class="gc-parlak-kenar"></div>
      <div class="gc-kose gc-kose--sol-ust"></div><div class="gc-kose gc-kose--sag-ust"></div><div class="gc-kose gc-kose--sol-alt"></div><div class="gc-kose gc-kose--sag-alt"></div>
      <div class="gc-kose-ic gc-kose-ic--sol-ust"></div><div class="gc-kose-ic gc-kose-ic--sag-ust"></div><div class="gc-kose-ic gc-kose-ic--sol-alt"></div><div class="gc-kose-ic gc-kose-ic--sag-alt"></div>
      <div class="gc-rarity-serit"></div><div class="gc-ic-glow"></div><div class="gc-desen"></div><div class="gc-shimmer"></div><div class="gc-holo"></div>
      <div class="gc-kenar-glow" [style.background]="kenarGlow"></div>
      <div class="gc-parcaciklar"><span class="gc-p gc-p--buyuk" style="--d:9s;--x:10%;--y:20%"></span><span class="gc-p" style="--d:12s;--x:80%;--y:40%"></span><span class="gc-p gc-p--kucuk" style="--d:7s;--x:45%;--y:75%"></span></div>
      <div class="gc-icerik">
        <div class="gc-hud-baslik">MALİYET KALEMİ</div>
        <div class="ml-ust">
          <div class="ml-ad gc-baslik-ana">{{ p()?.kalemAdi || 'Kalem' }}</div>
          <div class="ml-kategori-badge">{{ p()?.kategori || 'Malzeme' }}</div>
        </div>
        <div class="ml-tutar">{{ tutarFormatli() }} <span class="ml-birim">{{ p()?.birim || 'Adet' }}</span></div>
        @if (p()?.aciklama) { <div class="ml-aciklama">{{ p().aciklama }}</div> }
        <div class="gc-xp-bar"><div class="gc-xp-dolgu" [style.width.%]="gorunur() ? 60 : 0"></div></div>
      </div>
    </div>
  `,
  styles: [GC_BASE_CSS, `
    .gc { --accent: #d97706; --accent-rgb: 217,119,6; }
    .ml-ust { display: flex; justify-content: space-between; align-items: center; gap: 8px; }
    .ml-ad { font-size: 13px; font-weight: 700; color: var(--py-metin, #e2e8f0); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; flex: 1; }
    .ml-kategori-badge { font-size: 8px; font-weight: 700; letter-spacing: .08em; text-transform: uppercase; padding: 2px 8px; border-radius: 2px; color: #fff; background: var(--accent); flex-shrink: 0; }
    .ml-tutar { font-size: 22px; font-weight: 900; color: #fbbf24; font-variant-numeric: tabular-nums; text-shadow: 0 0 12px rgba(251,191,36,.3); }
    .ml-birim { font-size: 10px; font-weight: 500; color: var(--py-metin-ikincil, #64748b); margin-left: 4px; }
    .ml-aciklama { font-size: 10px; color: var(--py-metin-ikincil, #64748b); line-height: 1.4; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  `],
})
export class MaliyetKalemiKartComponent extends GameCardBase {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  katRenk = computed(() => KAT_RENK[this.p()?.kategori] || '#d97706');
  katRgb = computed(() => KAT_RGB[this.p()?.kategori] || '217,119,6');
  tutarFormatli = computed(() => {
    const tutar = this.p()?.tutar;
    if (tutar == null) return '0';
    return Number(tutar).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ₺';
  });
}
